export default __webpack_public_path__ + "static/B0220-890c16ed8f59be8b0741d45b1c2ec000.png";